import AlertPage from "components/common/AlertPage";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { accessToStream } from 'services/api';
import styles from 'components/common/SpectacleDetailSummary.module.css';
import { Alert } from "react-ionicons";
import Button from "components/common/Button";
import SpectacleDetailStream from "components/common/SpectacleDetailStream";
import Spinner from "components/common/Spinner";
import { useParams } from "react-router-dom";

const Stream = () => {
  const { streamCode } = useParams();
  const [codeAccessAlert, setCodeAccessAlert] = useState(null);
  const [streamSession, setStreamSession] = useState(null);
  const [iframeStream, setIframeStream] = useState(null);
  const [accessCode, setAccessCode] = useState('');
  const [accessCodeLoading, setAccessCodeLoading] = useState(false);

  useEffect(() => {
    if (streamCode) {
      setAccessCode(streamCode);
      (async () => {
        setAccessCodeLoading(true);
        const response = await accessToStream({ accessCode: streamCode })
        if (response.success) {
          setAccessCodeLoading(false);
          setCodeAccessAlert({ type: 'success', message: response.data.message });
          setStreamSession(response.data.sessionId);
          setIframeStream(response.data.iframe);
        } else {
          setAccessCodeLoading(false);
          setCodeAccessAlert({ type: 'error', message: response?.errors?.message || response?.errors?.error || 'Erreur lors de la tentative d\'accès au live.' });
        }
      })();
    }
  }, [streamCode]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Stream</title>
        <meta name="description" content="Regardez le stream en direct sur cette page." />
        <meta property="og:title" content="Stream en direct" />
        <meta property="og:description" content="Regardez le stream en direct sur cette page." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className={styles.spectacleDetailStream}>

        <div>


          <h1 style={{ textAlign: "center" }}>Regarder le stream en direct</h1>
          {/* Ajoutez ici le composant ou l'iframe du stream */}
          {codeAccessAlert && !iframeStream && (
            <div className={`${styles.alert} ${styles[codeAccessAlert?.type]}`}>
              {codeAccessAlert?.message}
            </div>
          )}
          {!accessCodeLoading && !iframeStream &&
            <div className={styles.liveButton}>
              <input type="text" placeholder='Saisissez un code de streaming'
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
              />
              <Button
                onClick={async () => {
                  setAccessCodeLoading(true);
                  setCodeAccessAlert(null);
                  const response = await accessToStream({ accessCode })
                  if (response.success) {
                    setAccessCodeLoading(false);
                    setCodeAccessAlert({ type: 'success', message: response.data.message });
                    setStreamSession(response.data.sessionId);
                    setIframeStream(response.data.iframe);
                  } else {
                    setAccessCodeLoading(false);
                    setCodeAccessAlert({ type: 'error', message: response?.errors?.message || response?.errors?.error || 'Erreur lors de la tentative d\'accès au live.' });
                  }
                }}

              >
                Regarder le live
              </Button>
            </div>
          }

          {!!iframeStream && <SpectacleDetailStream iframe={iframeStream} setVideoUrl={setIframeStream} sessionId={streamSession} />}

          {
            accessCodeLoading && <Spinner />
          }
        </div>
      </div>
    </div>
  );
};

export default Stream;





































